<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p><em>Call of the Wild</em>, a book by Jack London, inspired and set me on course for a life of adventure.</p><br/>
<p style="text-indent: 0em">‘There is nothing quite like being alone with nature deep in the middle of nowhere with only yourself to depend on.’</p><br/>
<p style="text-indent: 0em;">I dedicate, <em>Lionheart</em> to all living things.</p><br/>
<p style="text-align: right;">– James Wild</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?5e67364f